import { HateoasResource, Resource } from '@lagoshny/ngx-hateoas-client';
@HateoasResource('frontends', { routeName: 'frontdoorResourceRoute' })
export class Frontend extends Resource {
    id: string;
    status: string;
    name: string;
    domainName: string;
    selected: boolean;
    authProviderIds: any;

}


